import NextSection from "@components/About/NextSection";
import ImagesScrollbarGallery from "@components/ImagesScrollbarGallery";
import cx from "classnames";
import styles from "./Gallery.module.scss";
import _ from "lodash";
interface Props {
  data: {
    title: string;
    slider: {
      isAuto: boolean;
      interval: number;
      slides: {
        src: string;
        alt: string;
      }[];
    };
  };
}

export default function Gallery({ data }: Props) {
  return (
    <div data-scroll-section className={cx(styles.section)}>
      <NextSection className={cx(styles.nextSection)}>
        <div className={cx(styles.titleSection)}>{_.get(data, "title")}</div>
      </NextSection>
      <ImagesScrollbarGallery
        galleryName={"wellnessGallery"}
        isAuto={_.get(data, "slider.isAuto")}
        interval={_.get(data, "slider.interval")}
        images={_.get(data, "slider.slides")}
      />
    </div>
  );
}
